import { render, staticRenderFns } from "./AdminBusinessSettings.vue?vue&type=template&id=8ac1c17a"
import script from "./AdminBusinessSettings.vue?vue&type=script&lang=js"
export * from "./AdminBusinessSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports